module.exports = __webpack_public_path__ + "static/media/handwash.f4be2811.png";